import { render, staticRenderFns } from "./coupon_cd.vue?vue&type=template&id=2e00f5fc&scoped=true&"
import script from "./coupon_cd.vue?vue&type=script&lang=js&"
export * from "./coupon_cd.vue?vue&type=script&lang=js&"
import style0 from "./coupon_cd.vue?vue&type=style&index=0&id=2e00f5fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e00f5fc",
  null
  
)

export default component.exports